import styled from "styled-components";

import Modal from "src/components-v2/Modal";

export const StyledModal = styled(Modal)`
  > .c-modal__dialog {
    max-width: 412px !important;
  }
`;
